(() => {
  const controllers=new Map();
  function measure(){
    const bar=[...controllers.keys()].find(node=>node.isConnected);
    const height=bar?bar.getBoundingClientRect().height:0;
    document.documentElement.style.setProperty('--j22-announcement-height',height+'px');
    document.documentElement.classList.toggle('j22-has-announcement',height>0);
  }
  function mount(bar){
    if(controllers.has(bar))return;
    const ctl=new AbortController();
    function fill(){
      const groups=bar.querySelectorAll('[data-announcement-group]'),first=groups[0]?.firstElementChild;
      if(!first)return;
      const gap=parseFloat(getComputedStyle(groups[0]).columnGap)||0;
      const count=Math.max(4,Math.ceil((bar.clientWidth+gap)/Math.max(1,first.getBoundingClientRect().width+gap))+1);
      groups.forEach(group=>{
        while(group.children.length>count)group.lastElementChild.remove();
        while(group.children.length<count){const copy=first.cloneNode(true);copy.setAttribute('aria-hidden','true');group.append(copy);}
      });
    }
    const observer=new ResizeObserver(()=>{fill();measure();});observer.observe(bar);
    window.addEventListener('resize',()=>{fill();measure();},{signal:ctl.signal,passive:true});
    controllers.set(bar,()=>{ctl.abort();observer.disconnect();controllers.delete(bar);measure();});
    fill();measure();
    document.fonts?.ready.then(()=>{if(!ctl.signal.aborted){fill();measure();}});
  }
  function boot(scope){if(scope.matches?.('[data-announcement]'))mount(scope);scope.querySelectorAll('[data-announcement]').forEach(mount);measure();}
  boot(document);
  document.addEventListener('shopify:section:load',e=>boot(e.target));
  document.addEventListener('shopify:section:unload',e=>{for(const [bar,dispose]of controllers)if(bar===e.target||e.target.contains(bar))dispose();});
  document.addEventListener('shopify:section:reorder',measure);
  const form=document.getElementById('SaguaroItalianLocale');
  if(form&&!window.Shopify?.designMode){try{const key='saguaro-italian-locale:'+location.pathname;if(!sessionStorage.getItem(key)){sessionStorage.setItem(key,'1');const destination=form.querySelector('[name="return_to"]');if(destination)destination.value=location.pathname+location.search+location.hash;form.requestSubmit();}}catch{}}
})();
